<template>
  <div>
    <v-card>
      <v-card-subtitle>Informacion Adicional</v-card-subtitle>
      <v-card-text>
        <v-row>
          <v-col cols="12" sm="8" md="8">
            <v-text-field 
                v-model="camposBD.referencia_cliente"
                label="Referencia Cliente"
                clearable
                append-icon="mdi-notebook-check"
                ></v-text-field>
          </v-col>
          <v-col cols="12" sm="4" md="4">
            <v-combobox
            v-model="regimen"
            :items="regimenes"
            item-text="regimen"
            item-value="regimen"
            label="Régimen"
            append-icon="mdi-mailbox"
            return-object
            clearable
            ></v-combobox>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="8" md="8">
            <v-combobox
            v-model="cliente"
            :items="clientes"
            item-text="name"
            item-value="id"
            label="Facturar a"
            append-icon="mdi-handshake"
            return-object
            clearable
            ></v-combobox>
          </v-col>
          <v-col cols="12" sm="4" md="4">
            <v-combobox
            v-model="via"
            :items="vias"
            item-text="via"
            item-value="via"
            label="Vía"
            append-icon="mdi-sail-boat"
            return-object
            clearable
            ></v-combobox>
          </v-col>
        </v-row>
        <v-row>          
            <v-col cols="12" sm="4" md="4">
                <v-text-field             
                    v-model="camposBD.fecha_pickup"
                    label="Fecha PickUp"                    
                    type="date"                    
                    clearable                    
                    ></v-text-field>
            </v-col>
            <v-col cols="12" sm="4" md="4">
                <v-text-field             
                    v-model="camposBD.fecha_salida"
                    label="Fecha Salida"                    
                    type="date"                    
                    clearable                    
                    ></v-text-field>
            </v-col>
            <v-col cols="12" sm="4" md="4">
                <v-text-field             
                    v-model="camposBD.fecha_arribo"
                    label="Fecha Arribo"                    
                    type="date"                    
                    clearable                    
                    ></v-text-field>
            </v-col>            
        </v-row>
        <v-row>            
            <v-col cols="12" sm="4" md="4">
               <v-combobox
                v-model="arribo"
                :items="arribos"
                item-text="arribo"
                item-value="arribo"
                label="Arribo en"
                append-icon="mdi-map-marker-check"
                return-object
                clearable
                ></v-combobox>
            </v-col>
            <v-col cols="12" sm="4" md="4">
                <v-text-field             
                    v-model="camposBD.valor_declarado_aduana"
                    label="Valor Declarado Aduana"                    
                    type="number"                    
                    append-icon="mdi-cash"
                    clearable                    
                    ></v-text-field>
            </v-col>
            <v-col cols="12" sm="4" md="4">
                <v-text-field             
                    v-model="camposBD.fecha_envio_datos_agente"
                    label="Fecha Envio Datos Agente"                    
                    type="date"                    
                    clearable                    
                    ></v-text-field>
            </v-col>            
        </v-row>
        <v-row>          
            <v-col cols="12" sm="4" md="4">
                <v-text-field             
                    v-model="camposBD.fecha_declaracion"
                    label="Fecha Declaración"                    
                    type="date"                    
                    clearable                    
                    ></v-text-field>
            </v-col>
            <v-col cols="12" sm="4" md="4">
                <v-text-field             
                    v-model="camposBD.fecha_pago_imp"
                    label="Fecha Pago Impuestos"                    
                    type="date"                    
                    clearable                    
                    ></v-text-field>
            </v-col>
            <v-col cols="12" sm="4" md="4">
                <v-text-field             
                    v-model="camposBD.fecha_liberacion_aduana"
                    label="Fecha Liberación Aduana"                    
                    type="date"                    
                    clearable                    
                    ></v-text-field>
            </v-col>
        </v-row>
        <v-row>            
            <v-col cols="12" sm="6" md="6">
               <v-text-field 
                v-model="camposBD.pu_reference_shedule"
                label="PU Reference Schedule"
                clearable
                append-icon="mdi-file-document"
                ></v-text-field>
            </v-col>            
            <v-col cols="12" sm="6" md="6">
               <v-text-field 
                v-model="camposBD.cliente_operador_postal"
                label="Cliente Operador Postal"
                clearable
                append-icon="mdi-briefcase-account"
                ></v-text-field>
            </v-col>            
        </v-row>
        <v-row>
          <v-col cols="12" sm="6" md="6">
            <v-combobox
                v-model="tipopersona"
                :items="tipospersona"
                item-text="tipo"
                item-value="tipo"
                label="Tipo de Persona"
                append-icon="mdi-account-supervisor-circle-outline"
                return-object
                clearable
                ></v-combobox>
          </v-col>
          <v-col cols="12" sm="6" md="6">
            <v-combobox
                v-model="origen"
                :items="origenes"
                item-text="origen"
                item-value="origen"
                label="Origen"
                append-icon="mdi-office-building-marker"
                return-object
                clearable
                ></v-combobox>
          </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" sm="12" md="12">
                <v-text-field 
                v-model="camposBD.observaciones"
                label="Observaciones"
                clearable
                append-icon="mdi-file-eye"
                ></v-text-field>
            </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer
        ><v-btn color="primary" outlined @click="asignar()">
          Guardar <v-icon>mdi-content-save</v-icon></v-btn
        >
      </v-card-actions>
    </v-card>
    <v-overlay :value="overlay">
      <waiting />
    </v-overlay>
  </div>
</template>

<script>
import Waiting from "./Waiting.vue";
import apicon from "../plugins/apicon";
export default {
  props: {
    id: {
      type: Number,
      default: null,
    },
  },
  components: {
    Waiting,
  },
  watch:{
    cliente: function(item){
      if(item){
        this.camposBD.facturar_a = item.id
      }
    },
    via: function(item){
      if(item){
        this.camposBD.via = item.via
      }
    },
    regimen: function(item){
      if(item){
        this.camposBD.regimen = item.regimen
      }
    },
    arribo: function(item){
      if(item){
        this.camposBD.arribo_en = item.arribo
      }
    },
    tipopersona: function(item){
      if(item){
        this.camposBD.tipo_persona = item.tipo
      }
    },
    origen: function(item){
      if(item){
        this.camposBD.origen_per = item.origen;
      }
    }
  },
  created: function () {},
  data() {
    return {      
      camposBD: {
        fecha_pickup: null,
        fecha_arribo: null,
        fecha_envio_datos_agente: null,
        fecha_declaracion: null,
        fecha_pago_imp: null,
        fecha_liberacion_aduana: null,
        valor_declarado_aduana: null,
        observaciones: null,
        via: null,
        facturar_a: null,
        pu_reference_shedule: null,
        fecha_salida: null,
        referencia_cliente: null,
        regimen: null,
        arribo_en: null,
        tipo_persona: null,
        origen_per: null,
        cliente_operador_postal: "No",
      },           
      overlay: false,
      clientes: [],
      cliente: null,
      vias: [
        {via: "Aerea" },
        {via: "Maritima" }
      ],
      via: null,
      regimenes: [
        {regimen: "Courier"},
        {regimen: "Carga"},
        {regimen: "Correspondencia"},
      ],
      regimen: null,
      arribos: [
        {arribo: "Guayaquil"},
        {arribo: "Quito"},
      ],
      arribo: null,
      tipospersona:[
        {tipo: "Natural"},
        {tipo: "Juridica"}
      ],
      tipopersona: null,
      origenes: [
        {origen: "Privado"},
        {origen: "Publico"}
      ],
      origen: null,
    };
  },  
  methods: {    
    fillDatos: async function () {
      await apicon
        .getDataApi(apicon.getApiBaseUrl() + "guias/" + this.id)
        .then((result) => {
          if (result) {            
            this.camposBD.fecha_pickup = result.fecha_pickup;
            this.camposBD.fecha_arribo = result.fecha_arribo;
            this.camposBD.fecha_envio_datos_agente = result.fecha_envio_datos_agente;
            this.camposBD.fecha_declaracion = result.fecha_declaracion;
            this.camposBD.fecha_pago_imp = result.fecha_pago_imp;
            this.camposBD.fecha_liberacion_aduana = result.fecha_liberacion_aduana;
            this.camposBD.valor_declarado_aduana = result.valor_declarado_aduana;
            this.camposBD.observaciones = result.observaciones;
            this.via = this.vias.find((v) => v.via === result.via || {via: "Aerea"});
            this.camposBD.via = result.via;
            this.cliente = this.clientes.find((c) => c.id === result.facturar_a);
            this.camposBD.facturar_a = result.facturar_a;
            this.camposBD.pu_reference_shedule = result.pu_reference_shedule;
            this.camposBD.fecha_salida = result.fecha_salida;
            this.camposBD.referencia_cliente = result.referencia_cliente;
            this.regimen = this.regimenes.find((r) => r.regimen === result.regimen) || {regimen: "Courier"};
            this.camposBD.regimen = result.regimen;
            this.arribo = this.arribos.find((a) => a.arribo === result.arribo_en);
            this.camposBD.arribo_en = result.arribo_en;
            this.tipopersona = this.tipospersona.find((t) => t.tipo === result.tipo_persona) || {tipo : "Juridica"};
            this.camposBD.tipo_persona = result.tipo_persona != null ? result.tipo_persona : null;
            this.origen = this.origenes.find((o) => o.origen === result.origen_per) || {origen : "Privado"};
            this.camposBD.origen_per = result.origen_per != null ? result.origen_per : null;
            this.camposBD.cliente_operador_postal = result.cliente_operador_postal != null ? result.cliente_operador_postal : "No";
          }
        });
    },    
    asignar: async function (id) {      
      this.overlay = true;
      await apicon
        .updateDataApi(
          apicon.getApiBaseUrl() + "guias/" + this.id,
          this.camposBD
        )
        .then((result) => {
          this.overlay = false;
          this.$swal(result.message);
        });      
    },    
    fillClientes: function () {
      apicon.getDataApi(apicon.getApiBaseUrl() + "usuario").then((result) => {
        this.clientes = result;
      });
    },
  },
  mounted: async function () {
    apicon.setAuthHeaders();
    await this.fillClientes();       
    await this.fillDatos();     
  },
};
</script>